import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box,
  Button,
  DashboardModule,
} from '@domain-group/suit-theme'

import useAttachment from '@hooks/useAttachment'
import useAttachments from '@hooks/useAttachments'

import AssetListItem from './AssetListItem'

const EntityAssets = (props) => {
  const {
    callbacks,
    filters: {
      attachableId,
      attachableType,
      attachmentType,
    },
  } = props

  const attachmentParams = {
    attachable_id: attachableId,
    attachable_type: attachableType,
    attachment_type: attachmentType,
  }

  const attachmentPayload = useAttachment()
  const {
    callbacks: { uploadAttachment },
  } = attachmentPayload

  const attachmentsPayload = useAttachments({
    entityKey: attachableType + attachableId,
    filters: attachmentParams,
    performHttpRequests: !!attachableType && !!attachableId,
  })

  const {
    filteredAttachments,
    hasFilteredAttachments,
    loading,
  } = attachmentsPayload

  return (
    <DashboardModule title="Assets" loading={loading}>
      <Box flexDirection="column">
        {!loading && hasFilteredAttachments && (
          <DashboardModule.ScrollableSection>
            {filteredAttachments.map(attachment => (
              <AssetListItem
                attachment={attachment}
                callbacks={callbacks}
                key={attachment.id}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.Footer
          boxProps={{
            borderTop: !hasFilteredAttachments ? 'none' : '1px solid',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => uploadAttachment(attachmentParams)}
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Upload Assets
          </Button>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

EntityAssets.propTypes = {
  callbacks: PropTypes.object.isRequired,
  filters: PropTypes.shape({
    attachableId: PropTypes.number.isRequired,
    attachableType: PropTypes.string.isRequired,
    attachmentType: PropTypes.string,
  }).isRequired,
}

export default EntityAssets
